import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Typography, Button, Box } from '@material-ui/core';
import { ROUTES } from '../../router/routes';
import ErrorTemplate from '../ErrorTemplate';
import './../Error.scss';

const Unavailable = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <ErrorTemplate>
      <Typography className="info__primary" variant="h1">
        {t('error.503.title')}
      </Typography>
      <Typography className="info__secondary" variant="h2">
        {t('error.503.content')}
      </Typography>
      <Box className="info__bnt">
        <Button
          className="bnt"
          variant="contained"
          size="large"
          onClick={() => {
            history.push(ROUTES.DASHBOARD);
          }}
        >
          {t('dashboard.home_page')}
        </Button>
      </Box>
    </ErrorTemplate>
  );
};

export default Unavailable;
